import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createUserSatisfactionItemService,
  deleteUserSatisfactionItemService,
  editUserSatisfactionItemService,
  getUserSatisfactionItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const userSatisfactionAdminContext = createContext({
  userSatisfactionItems: [],
  setUserSatisfactionItems: () => {},
  userSatisfaction: {},
  setUserSatisfaction: () => {},
  id: "",
  setId: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetUserSatisfactionItemList: () => {},
  handleCreateUserSatisfactionItem: () => {},
  handleEditUserSatisfactionItem: () => {},
  handleDeleteUserSatisfactionItem: () => {},
});

const UserSatisfactionAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [userSatisfactionItems, setUserSatisfactionItems] = useState([]);
  const [userSatisfaction, setUserSatisfaction] = useState({});
  const [id, setId] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setIcon("");
    setDescription("");
  };

  // Create User Satisfaction Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setIcon(itemValue.icon);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details User Satisfaction Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setUserSatisfaction(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setUserSatisfaction({});
  };

  // Handle Get User Satisfaction Item List Method
  const handleGetUserSatisfactionItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getUserSatisfactionItemsService(objData);
      if (status === 200) {
        setUserSatisfactionItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create User Satisfaction Item Method
  const handleCreateUserSatisfactionItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createUserSatisfactionItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetUserSatisfactionItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit User Satisfaction Item Method
  const handleEditUserSatisfactionItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editUserSatisfactionItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetUserSatisfactionItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete User Satisfaction Item Method
  const handleDeleteUserSatisfactionItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteUserSatisfactionItemService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetUserSatisfactionItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <userSatisfactionAdminContext.Provider
      value={{
        userSatisfactionItems,
        setUserSatisfactionItems,
        userSatisfaction,
        setUserSatisfaction,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        icon,
        setIcon,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetUserSatisfactionItemList,
        handleCreateUserSatisfactionItem,
        handleEditUserSatisfactionItem,
        handleDeleteUserSatisfactionItem,
      }}
    >
      {children}
    </userSatisfactionAdminContext.Provider>
  );
};

export default UserSatisfactionAdminContext;
